import { SHTableCell } from "@components/design-systems";
import { FeatureAnalysisRowDTO } from "@models/platform-analysis/entities/steps/feature";
import { Cell, flexRender } from "@tanstack/react-table";
import { memo, useMemo } from "react";
import { TableVirtualizationConfigs } from "../../../configs";

type AnalysisTableVirtualizedCellProps = {
  cell: Cell<FeatureAnalysisRowDTO, unknown>;
};
export const AnalysisTableVirtualizedCell = memo(
  ({ cell }: AnalysisTableVirtualizedCellProps) => {
    const { getStart, getSize, columnDef } = cell?.column || {};

    const cellContent = useMemo(
      () => flexRender(columnDef?.cell, cell.getContext()),
      [columnDef?.cell, cell],
    );

    return (
      <SHTableCell
        sx={{
          minHeight: TableVirtualizationConfigs.DefaultRowHeight,
          height: "100%",
          position: "absolute",
          display: "flex",
          left: getStart(),
          width: getSize(),
          flexShrink: 0,
          padding: 0,
        }}
      >
        {cellContent}
      </SHTableCell>
    );
  },
);
